/** The chooser hides this pseudo-category, so the organizer does too. */
export const UNCATEGORIZED_CODE = "MapLayerCategory_Uncategorized"
